export const ROOMW = 'ROOMW'
export const ROOMH = 'ROOMH'
export const ROOMD = 'ROOMD'
export const PJX = 'PJX'
export const PJY = 'PJY'
export const PJZ = 'PJZ'
export const SCRNW = 'SCRNW'
export const SCRNH = 'SCRNH'
export const BOARDW = 'BOARDW'
export const BOARDH = 'BOARDH'
export const F_S2D = 'F_S2D'
export const F_D2S = 'F_D2S'
export const VLENSSHIFT = 'VLENSSHIFT'
export const HLENSSHIFT = 'HLENSSHIFT'
export const VHLENSSHIFT = 'VHLENSSHIFT'
export const DIST = 'DIST'
export const PJHEIGHT = 'PJHEIGHT'
export const F_VOFFSET = 'F_VOFFSET'
export const PROPORTION = 'PROPORTION'
export const ASPECTRATIO = 'ASPECTRATIO'

export const USERINPUTMODELNAME = 'USERINPUTMODELNAME'
export const INSTALLMATCHINGMODELDATA = 'INSTALLMATCHINGMODELDATA'
export const SPECIFICATIONMATCHINGMODELDATA = 'SPECIFICATIONMATCHINGMODELDATA'
export const SEARCHMATCHINGMODELDATA = 'SEARCHMATCHINGMODELDATA'
export const SEARCHSELECTEDMODELDATA = 'SEARCHSELECTEDMODELDATA'
export const SEARCHMATCHINGLENSID = 'SEARCHMATCHINGLENSID'
export const SEARCHSELECTEDLENSDATA = 'SEARCHSELECTEDLENSDATA'
export const SELECTRATIODATA = 'SELECTRATIODATA'

export const BMMATCHINGMODELDATA = 'BMMATCHINGMODELDATA'
export const BMSELECTEDMODELDATA = 'BMSELECTEDMODELDATA'
export const BMMATCHINGLENSID = 'BMMATCHINGLENSID'
export const BMSELECTEDLENSDATA = 'BMSELECTEDLENSDATA'

export const HTMMATCHINGMODELDATA = 'HTMMATCHINGMODELDATA'
export const HTMSELECTEDMODELDATA = 'HTMSELECTEDMODELDATA'
export const HTMMATCHINGLENSID = 'HTMMATCHINGLENSID'
export const HTMSELECTEDLENSDATA = 'HTMSELECTEDLENSDATA'

export const MATCHINGMODELDATA = 'MATCHINGMODELDATA'
export const SELECTEDMODELDATA = 'SELECTEDMODELDATA'
export const MATCHINGLENSID = 'MATCHINGLENSID'
export const SELECTEDLENSDATA = 'SELECTEDLENSDATA'

export const CATERADIO = 'CATERADIO'
export const CATEVALUE = 'CATEVALUE'
export const SCREENSIZE = 'SCREENSIZE'
export const SET_UNIT = 'SET_UNIT'
export const SET_OTHER_POSITION = 'SET_OTHER_POSITION'
export const SET_GRAPH_ROOMW = 'SET_GRAPH_ROOMW'
export const SET_GRAPH_ROOMH = 'SET_GRAPH_ROOMH'
export const SET_GRAPH_ROOMD = 'SET_GRAPH_ROOMD'
export const SET_GRAPH_PJY = 'SET_GRAPH_PJY'
export const SET_GRAPH_SCRNW = 'SET_GRAPH_SCRNW'
export const SET_GRAPH_SCRNH = 'SET_GRAPH_SCRNH'
export const SET_SCREENSIZE = 'SET_SCREENSIZE'
export const SET_BRIGHTNESS = 'SET_BRIGHTNESS'
export const SET_VANGLE = 'SET_VANGLE'
export const SET_VANGLEFLAG = 'SET_VANGLEFLAG'
export const SET_HANGLE = 'SET_HANGLE'
export const SET_HANGLEFLAG = 'SET_HANGLEFLAG'
export const SET_OFFSET = 'SET_OFFSET'
export const SET_FLOOR2BOTTOM = 'SET_FLOOR2BOTTOM'
export const SET_SELECTEDLENSDATA_ASPECTRATIO = 'SET_SELECTEDLENSDATA_ASPECTRATIO'
export const SET_VLENSSHIFT = 'SET_VLENSSHIFT'
export const SET_HLENSSHIFT = 'SET_HLENSSHIFT'
export const SET_INITSCREENSIZEW = 'SET_INITSCREENSIZEW'
export const SET_INITSCREENSIZEH = 'SET_INITSCREENSIZEH'
export const SET_OLDTX = 'SET_OLDTX'
export const SET_OLDTY = 'SET_OLDTY'
export const SET_PJIMGTYPE = 'SET_PJIMGTYPE'
export const SET_GAIN = 'SET_GAIN'
export const SET_APPLICATION = 'SET_APPLICATION'
export const SET_PROJECTORCHECKED = 'SET_PROJECTORCHECKED'
export const SET_THROWDISTANCECHECKED = 'SET_THROWDISTANCECHECKED'
export const SET_SCREENSIZECHECKED = 'SET_SCREENSIZECHECKED'
export const SET_REALTHROWDISTANCECHECKED = 'SET_REALTHROWDISTANCECHECKED'
export const SET_USTTHROWDISSLIDERTMAX = 'SET_USTTHROWDISSLIDERTMAX'
export const SET_USTSCREENSIZEMAX = 'SET_USTSCREENSIZEMAX'
export const SET_PJZTIP = 'SET_PJZTIP'
export const SET_PJXTIP = 'SET_PJXTIP'
export const SET_DRAWDATA = 'SET_DRAWDATA'
export const SET_BLACKDRAWDATA = 'SET_BLACKDRAWDATA'
export const SET_CENTERPOSITIONINIT = 'SET_CENTERPOSITIONINIT'
export const SET_RANGEDRAWDATA = 'SET_RANGEDRAWDATA'
export const SET_CENTERPOINTDATA = 'SET_CENTERPOINTDATA'
export const CHANGE_VIEW = 'CHANGE_VIEW'
export const SET_BLACKSIZE = 'SET_BLACKSIZE'
export const SET_PROJECTORCHECKEDSIDE = 'SET_PROJECTORCHECKEDSIDE'
export const SET_PROJECTORCHECKEDTOP = 'SET_PROJECTORCHECKEDTOP'
export const SET_FLTOB = 'SET_FLTOB'
export const SET_FLTOL = 'SET_FLTOL'
export const SET_DASHFLAG = 'SET_DASHFLAG'
export const SET_DASHDATA = 'SET_DASHDATA'
export const SET_DASHDATAREMAIN = 'SET_DASHDATAREMAIN'
export const SET_ISTOUCH = 'SET_ISTOUCH'
export const SET_THEME = 'SET_THEME'
export const SET_SCREEN4POINT = 'SET_SCREEN4POINT'
export const SET_POSITION = 'SET_POSITION'
export const SET_SCREENMOVECHECKED = 'SET_SCREENMOVECHECKED'
export const SET_THREEDPJCHECKED = 'SET_THREEDPJCHECKED'
export const SET_FOCUSVIEW = 'SET_FOCUSVIEW'
export const SET_BROWSERTYPE = 'SET_BROWSERTYPE'
export const SET_TEMVLENSSHIFT = 'SET_TEMVLENSSHIFT'
export const SET_ISUSTWALL = 'SET_ISUSTWALL'
export const SET_USTPJTOP = 'SET_USTPJTOP'
export const SET_USTVDRAGFLAG = 'SET_USTVDRAGFLAG'
export const SET_USTLENSHIFTV = 'SET_USTLENSHIFTV'
export const SET_BOARDSTATUSTOP = 'SET_BOARDSTATUSTOP'
export const SET_TOUCHINSTALL = 'SET_TOUCHINSTALL'
export const SET_FINGERTOUCHSTATUS = 'SET_FINGERTOUCHSTATUS'
export const SET_FTULOCATIONSTATE = 'SET_FTULOCATIONSTATE'
export const SET_WHITEBOARDSTATUS = 'SET_WHITEBOARDSTATUS'
export const SET_SHOWINPUTFLAG = 'SET_SHOWINPUTFLAG'
export const SET_TEXTDATA = 'SET_TEXTDATA'
export const SET_KEYSTONEVERTICAL = 'SET_KEYSTONEVERTICAL'
export const SET_KEYSTONEHORIZONTAL = 'SET_KEYSTONEHORIZONTAL'
export const SET_ISVANGLEOUT = 'SET_ISVANGLEOUT'
export const SET_OUTOFSPECVAL = 'SET_OUTOFSPECVAL'
export const SET_ISOUTOFSPEC = 'SET_ISOUTOFSPEC'
export const SET_LANGUAGEDEFAULT = 'SET_LANGUAGEDEFAULT'
export const SET_SEARCHTABACTIVE = 'SET_SEARCHTABACTIVE'
export const SET_USTLENSTOFRONTPJ = 'SET_USTLENSTOFRONTPJ'
export const SET_CURVESHAPE = 'SET_CURVESHAPE'
export const SET_CURVEDIRECTION = 'SET_CURVEDIRECTION'
export const SET_MUPOINTS = 'SET_MUPOINTS'
export const SET_CURVEDEPTH = 'SET_CURVEDEPTH'
export const SET_CURVECENTER = 'SET_CURVECENTER'
export const SET_CURVERADIUS = 'SET_CURVERADIUS'
export const SET_CURVECENTRALANGLE = 'SET_CURVECENTRALANGLE'
export const SET_ISSIMPLE = 'SET_ISSIMPLE'
export const SET_LENSSHIFTRANGEBOOL = 'SET_LENSSHIFTRANGEBOOL'
export const SET_LENSSHIFTRANGE = 'SET_LENSSHIFTRANGE'
export const SET_BRIGHTNESSGUIDE = 'SET_BRIGHTNESSGUIDE'
export const SET_SIMPLEPJTOP = 'SET_SIMPLEPJTOP'
export const SET_SETTINGACTIVE = 'SET_SETTINGACTIVE'
export const SET_FONTSIZE = 'SET_FONTSIZE'
export const SET_TABACTIVENAME = 'SET_TABACTIVENAME'
export const SET_INDANGLESWITCH = 'SET_INDANGLESWITCH'
export const SET_INDANGLEREMAINPINTS = 'SET_INDANGLEREMAINPINTS'
export const SET_CORNERCORAREAS = 'SET_CORNERCORAREAS'
export const SET_ISONCORNERAREAS = 'SET_ISONCORNERAREAS'
export const SET_TOUCHWALLFLAG = 'SET_TOUCHWALLFLAG'
export const SET_BLENDING_SCREEN_SHAPE = 'SET_BLENDING_SCREEN_SHAPE'
export const SET_BLENDING_SCREEN_SHAPESHOW = 'SET_BLENDING_SCREEN_SHAPESHOW'
export const SET_BLENDING_SCREEN_WIDHT = 'SET_BLENDING_SCREEN_WIDHT'
export const SET_BLENDING_SCREEN_HEIGHT = 'SET_BLENDING_SCREEN_HEIGHT'
export const SET_BLENDING_RATIO = 'SET_BLENDING_RATIO'
export const SET_BLENDING_RADIUS = 'SET_BLENDING_RADIUS'
export const SET_BLENDING_CURVESELECT = 'SET_BLENDING_CURVESELECT'
export const SET_BLENDING_ANGLE = 'SET_BLENDING_ANGLE'
export const SET_BLENDING_DEPTH = 'SET_BLENDING_DEPTH'
export const SET_BLENDING_ARC = 'SET_BLENDING_ARC'
export const SET_BLENDING_SCREENHEIGHT = 'SET_BLENDING_SCREENHEIGHT'
export const SET_BLENDING_LENSHEIGHT = 'SET_BLENDING_LENSHEIGHT'
export const SET_BLENDING_LENSHEIGHTRATE_MIN = 'SET_BLENDING_LENSHEIGHTRATE_MIN'
export const SET_BLENDING_LENSHEIGHTRATE_MAX = 'SET_BLENDING_LENSHEIGHTRATE_MAX'
export const SET_BLENDING_AVAPOINT = 'SET_BLENDING_AVAPOINT'
export const SET_BLENDING_LENSSHIFTV = 'SET_BLENDING_LENSSHIFTV'
export const SET_BLENDING_ISPROJECTPOSITION = 'SET_BLENDING_ISPROJECTPOSITION'
export const SET_BLENDING_SIMULATETABDATA = 'SET_BLENDING_SIMULATETABDATA'
export const SET_BLENDING_SIMULATETABSELE = 'SET_BLENDING_SIMULATETABSELE'
export const SET_BLENDINGUNIT = 'SET_BLENDINGUNIT'
export const SET_BLENDING_POSITION = 'SET_BLENDING_POSITION'
export const SET_BLENDING_SELENSDATA = 'SET_BLENDING_SELENSDATA'
export const SET_BLENDING_HLENSSHIFT = 'SET_BLENDING_HLENSSHIFT'
export const SET_BLENDING_VLENSSHIFT = 'SET_BLENDING_VLENSSHIFT'
export const SET_BLENDING_VHLENSSHIFT = 'SET_BLENDING_VHLENSSHIFT'
export const SET_BLENDING_VLENSSHIFTNOW = 'SET_BLENDING_VLENSSHIFTNOW'
export const SET_SCREENSIZEACTIVE = 'SET_SCREENSIZEACTIVE'
export const SET_DISABLEDNONE = 'SET_DISABLEDNONE'
export const SET_BLENDING_RANGE_MIN = 'SET_BLENDING_RANGE_MIN'
export const SET_BLENDING_RANGE_MAX = 'SET_BLENDING_RANGE_MAX'
export const SET_BLENDING_NUMBER_H = 'SET_BLENDING_NUMBER_H'
export const SET_BLENDING_NUMBER_V = 'SET_BLENDING_NUMBER_V'
export const SET_BLENDING_POSITIONLIMITW = 'SET_BLENDING_POSITIONLIMITW'
export const SET_BLENDING_POSITIONLIMITH = 'SET_BLENDING_POSITIONLIMITH'
export const SET_SIMULATESWITCHFLAG = 'SET_SIMULATESWITCHFLAG'
export const SET_BLENDINGEDGEPOINTS = 'SET_BLENDINGEDGEPOINTS'
export const SET_THROWACTIVE = 'SET_THROWACTIVE'
export const SET_THROWDISSLIDERTFORMAT = 'SET_THROWDISSLIDERTFORMAT'
export const SET_THROWDISSLIDERWFORMAT = 'SET_THROWDISSLIDERWFORMAT'
export const SET_RATIOSCREENSIZEMIN = 'SET_RATIOSCREENSIZEMIN'
export const SET_RATIOSCREENSIZEMAX = 'SET_RATIOSCREENSIZEMAX'
export const SET_THROWERROR = 'SET_THROWERROR'
export const SET_MDDEDATA = 'SET_MDDEDATA'
export const SET_FROMBLENDING = 'SET_FROMBLENDING'
export const SET_BLENDING = 'SET_BLENDING'
export const SET_THROWDISTANCE2SCREENSIZWIDTH = 'SET_THROWDISTANCE2SCREENSIZWIDTH'
export const SET_LANGUAGEFLAG = 'SET_LANGUAGEFLAG'
export const SET_MIXRATEHVAL = 'SET_MIXRATEHVAL'
export const SET_MIXRATEVVAL = 'SET_MIXRATEVVAL'
export const SET_FLOORFOOTPROJECTORCHECKED = 'SET_FLOORFOOTPROJECTORCHECKED'
export const SET_CONTRASTDATA = 'SET_CONTRASTDATA'
export const SET_DISTANCE2WALL = 'SET_DISTANCE2WALL'
export const SET_CURVEDCORRECTIONSCREEN_W = 'SET_CURVEDCORRECTIONSCREEN_W'
export const SET_CURVEDCORRECTIONSCREEN_H = 'SET_CURVEDCORRECTIONSCREEN_H'
export const SET_CURVEDCORRECTIONSCREEN_SIZE = 'SET_CURVEDCORRECTIONSCREEN_SIZE'
export const SET_ALL = 'SET_ALL'
export const SET_SAVE_DATE = 'SET_SAVE_DATE'
export const SET_RESET_STATE = 'SET_RESET_STATE'
export const SET_HISTORY_RADIO = 'SET_HISTORY_RADIO'
export const SET_HISTORY_KEY = 'SET_HISTORY_KEY'
export const SET_THROWDISSLIDERMIN = 'SET_THROWDISSLIDERMIN'
export const SET_THROWDISSLIDERMAX = 'SET_THROWDISSLIDERMAX'
export const SET_THROWDISSLIDERW = 'SET_THROWDISSLIDERW'
export const SET_THROWDISSLIDERT = 'SET_THROWDISSLIDERT'
export const SET_OVERLAPH = 'SET_OVERLAPH'
export const SET_OVERLAPV = 'SET_OVERLAPV'
export const SET_ISHISTORYROWCLICK = 'SET_ISHISTORYROWCLICK'
export const SET_CORRECTIONNGINFOMSG = 'SET_CORRECTIONNGINFOMSG'



// WEBPACK FOOTER //
// ./src/store/mutations_types.js